export default __webpack_public_path__ + "static/media/power.6200fa9d.png";